import React from 'react'
import { useTranslation } from 'react-i18next'

import FieldLabelWrapper from '../../../../../../../features/components/Form/FieldLabelWrapper'
import CountryOfOperationField from '../../../components/CountryOfOperationField'
import StakeholderMetricsFields from '../../../components/StakeholderMetricsFields'

import { COUNTRY_ID } from '../../../fields'

import useDrawerFormStyles from '../../../../../../../styles/common/drawerForms'
import useStyles from './styles'

const InputsPresetEditFormContent = ({ formik }) => {
  const { t } = useTranslation()
  const drawerFormClasses = useDrawerFormStyles()
  const classes = useStyles()

  return (
    <>
      <section className={drawerFormClasses.section}>
        <FieldLabelWrapper
          label={t('Country of Operation')}
          labelFor={COUNTRY_ID}
          className={classes.countryFieldWrapper}
        >
          <CountryOfOperationField formik={formik} />
        </FieldLabelWrapper>
      </section>

      <section className={drawerFormClasses.section}>
        <h4 className={drawerFormClasses.sectionTitle}>{t('Stakeholder details')}</h4>
        <p>{t('Enter the stakeholder detail values you want to pre-set for all reports')}</p>
        <br />
        <section className={drawerFormClasses.section}>
          <StakeholderMetricsFields formik={formik} index={0} />
        </section>
      </section>
    </>
  )
}

export default InputsPresetEditFormContent
